const ConditionalWrapperComponent = ({ condition, wrapper, children }) => {
  return condition ? wrapper(children) : children;
};

export { ConditionalWrapperComponent as ConditionalWrapper };
